module.exports = __webpack_public_path__ + "static/media/users-medical.486a5599.svg";